<template>
  <div class="footer">
    <h6>Developed in Vue, visit <a :href="linkUrl">{{linkUrl}}</a></h6>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    linkUrl: {
      type: String,
      default: 'https://www.jeffludden.com',
    },
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: rgb(55,61,71);
  color: #fff;
  margin: 0;
  padding: 1.5rem;
  text-align: center;
  & h6 {
    margin: 0;
    font-weight: normal;
  }
  & a {
    color: #60AFFE;
  }
}
</style>
